// MixpanelChores.jsx
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import {
  updatePubSubConfig,
  updateMixpanelReplayConfig,
  mixpanelStartBatchSenders,
} from '../resource/mixpanel.js';

const DEFAULT_INIT_EVENTS = ['load'];

// Update mixpanel $device_id is in PusherEmitter.jsx to avoid the update timing issue
// Might need to figure out a better way to refactor
export const MixpanelChores = ({
  pubSubTopic = '',
  pubSubPrefix = '',
  pubSubPostfix = '',
  replayRecordConfig = '',
  mixpanelInitEvents = DEFAULT_INIT_EVENTS,
}) => {
  const prevPubSubTopic = useRef(pubSubTopic);
  const prevPubSubPrefix = useRef(pubSubPrefix);
  const prevPubSubPostfix = useRef(pubSubPostfix);
  const prevReplayRecordConfig = useRef(replayRecordConfig);

  const flushMixpanelEvents = async () => {
    detachListeners();
    mixpanelStartBatchSenders();
  };

  const attachListeners = () => {
    mixpanelInitEvents.forEach(event => {
      document.addEventListener(event, flushMixpanelEvents);
    });
  };

  const detachListeners = () => {
    mixpanelInitEvents.forEach(event => {
      document.removeEventListener(event, flushMixpanelEvents);
    });
  };

  useEffect(() => {
    const shouldUpdatePubSubConfig =
      pubSubTopic &&
      pubSubTopic !== prevPubSubTopic.current &&
      pubSubPrefix &&
      pubSubPrefix !== prevPubSubPrefix.current &&
      pubSubPostfix &&
      pubSubPostfix !== prevPubSubPostfix.current;

    if (shouldUpdatePubSubConfig) {
      prevPubSubTopic.current = pubSubTopic;
      prevPubSubPrefix.current = pubSubPrefix;
      prevPubSubPostfix.current = pubSubPostfix;
      updatePubSubConfig({ pubSubTopic, pubSubPrefix, pubSubPostfix });
    }
  }, [pubSubTopic, pubSubPrefix, pubSubPostfix]);

  useEffect(() => {
    if (
      replayRecordConfig &&
      replayRecordConfig !== prevReplayRecordConfig.current
    ) {
      prevReplayRecordConfig.current = replayRecordConfig;
      updateMixpanelReplayConfig(replayRecordConfig);
    }
  }, [replayRecordConfig]);

  useEffect(() => {
    if (!mixpanelInitEvents.includes('load')) attachListeners();

    return () => {
      if (!mixpanelInitEvents.includes('load')) detachListeners();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mixpanelInitEvents]);

  return null;
};

MixpanelChores.propTypes = {
  pubSubTopic: PropTypes.string,
  pubSubPrefix: PropTypes.string,
  pubSubPostfix: PropTypes.string,
  mixpanelInitEvents: PropTypes.array,
  replayRecordConfig: PropTypes.string,
};

export default MixpanelChores;
